if (window.jQuery) {

    (function ($) {

        // const options = {
        //     project_id: "204292",
        //     sku: "ravenswatch",
        //     item_type: "unit",
        //     user: {
        //         locale: _locale,
        //     },
        //     api_settings: {
        //         sandbox: false,
        //     },
        //     widget_ui: {
        //         template: 'simple',
        //         target_element: "#buy-button",
        //     },
        //     access_data: {
        //         settings: {
        //             ui: {
        //                 theme: "dark"
        //             }
        //         }
        //     },
        //     payment_widget_ui: {
        //         lightbox: {
        //             width: '740px',
        //             height: '735px',
        //             spinner: 'round',
        //             spinnerColor: '#ffffff',
        //             contentBackground: "rgba(0,0,0,0.5)"
        //         }
        //     }
        // };
        //
        // const s = document.createElement('script');
        // s.type = "text/javascript";
        // s.async = true;
        // s.src = "https://cdn.xsolla.net/embed/buy-button/3.1.8/widget.min.js";
        // s.addEventListener('load', () => {
        //     XBuyButtonWidget.create(options);
        // }, false);
        //
        // const head = document.getElementsByTagName('head')[0];
        // head.appendChild(s);
        //
        //
        $(document).ready(function () {

            setTimeout(function () {
                $('#header .header-content img ').animate({opacity: 1}, 1500);
            }, 1500);

        });

        // Dealing with scroll behavior on anchor links
        $('.wp-block-lazyblock-header .btn-buy').off('click').on('click', function (e) {

            e.preventDefault();

            var _href = $(this).attr('href');
            var _scrollTop = $(_href).offset().top - 75;
            $('html,body').animate({scrollTop: _scrollTop}, 1000, 'swing');

        });

    })(jQuery);

}